import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Title, SubTitle, LeftSide, Column, InputContainer, StyledInputWidth, Skip } from '../SignupPage.styles';
import Button from '../../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../../assets/icons/logoBlack.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllVendorCategories } from '../../../../store/slice/vendor/asyncThunks';
import { selectOnboardingInfo, setOnboardingInfo } from '../../../../store/slice/onboarding/slice';
import { ReactComponent as LeftChevron } from '../../../../assets/icons/chevronLeft.svg';
import { useNavigate } from 'react-router-dom';

const Step2Page = ({ onContinueClick }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  const { googlePlaceId } = useSelector(selectOnboardingInfo);
  const navigation = useNavigate();

  useEffect(() => {
    dispatch(fetchAllVendorCategories());
    setValue(googlePlaceId ? googlePlaceId : '');
  }, [dispatch, googlePlaceId]);

  const onContinue = () => {
    onContinueClick(value);
    window.scrollTo(0, 0);
  };

  return (
    <LeftSide>
      <LeftChevron
        width={20}
        height={20}
        onClick={() => {
          navigation(-1);
        }}
        className="icon-back"
      />

      <Logo width={110} height={58} />

      <Column>
        <SubTitle>Step 2</SubTitle>
        <Title>Find your place on map</Title>
      </Column>
      <InputContainer>
        <StyledInputWidth placeholder={'Place Id'} value={value} onChange={e => setValue(e.target.value)} />
      </InputContainer>

      <Button title={'Continue'} onClick={onContinue} centered width />
      <Skip onClick={onContinue}>Skip</Skip>
    </LeftSide>
  );
};

export default Step2Page;
